export default __webpack_public_path__ + "static/media/banner-convenio-desk.2338e170.svg";